import axios from 'axios'

const productByIdQuery = `query ProductByIdQuery($id: Long!) {
  productById(id: $id) {
    handle
  }
}`

export const getProductById = async (
  variables: Record<string, string | number>
) => {
  const { data } = await axios({
    method: 'post',
    url: `https://${process.env.CONTENT_API_DOMAIN}/graphql`,
    headers: {
      Accept: 'application/json',
      'x-api-key': process.env.CONTENT_API_API_KEY!
    },
    data: {
      query: productByIdQuery,
      variables
    }
  })

  return data.data
}
